export enum phoneType {
    Movil = "Movil",
    Fijo = "Fijo",
}
